import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';

import { AuthService } from './auth.service';

/**
 * Protects routes that require an authenticated session.
 *
 * Calls `GET /api/user/current` to confirm the session. Authenticated
 * users are let through. Unauthenticated guests and all errors
 * (network, 5xx, etc.) are redirected to `/login`.
 */
export const authGuard: CanActivateFn = (): Observable<
  boolean | ReturnType<Router['createUrlTree']>
> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.currentUser$.pipe(
    map(user => (user !== null ? true : router.createUrlTree(['/login']))),
    catchError(() => of(false))
  );
};
